export const zIndex = {
  zIndex: {
    top: '100',
  },
};
